module.exports = __webpack_public_path__ + "img/bg.5b1ac1f1.jpg";